<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <div class="row">
                    <div class="col-md col-sm-6">
                        <form-input v-model="query.syear" id="syear" label="學年度" type="number"></form-input>
                    </div>
                    <div class="col-md col-sm-6">
                        <form-select v-model="query.semester" id="semester" label="學期">
                            <div is="option" value="">全部</div>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                </div>
            </div>
            <div class="page-border">
                <div class="row">
                    <div class="col-12 mb-3">
                        <b-button variant="success" @click="file('R1')">班會紀錄表</b-button>
                    </div>
                    <div class="col-12 mb-3">
                        <b-button variant="success" @click="file('R2')">賃居調查統計</b-button>
                    </div>
                    <div class="col-12 mb-3">
                        <b-button variant="success" @click="file('R3')">教室整潔報表</b-button>
                    </div>
                    <div class="col-12 mb-3">
                        <b-button variant="success" @click="file('R4')">導師夜間輔導紀錄表</b-button>
                    </div>
                    <!--<div class="col-12 mb-3">
                        <b-button variant="success" @click="file('R5')">學生獎懲統計表</b-button>
                    </div>-->
                </div>
            </div>
        </div>
    </page-main>
</template>

<script>
    export default {
        name: 'g2report',
        data: function () {
            return {
                query: { syear: '', semester: '' }
            }
        },
        methods: {
            file: function (action) {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/g2report/" + action + "?" + new URLSearchParams(this.query).toString();
                $a.click();
            }
        }
    };
</script>

<style>
</style>